import { render, staticRenderFns } from "./questionPreview.vue?vue&type=template&id=5ea30c6e&scoped=true&"
import script from "./questionPreview.vue?vue&type=script&lang=js&"
export * from "./questionPreview.vue?vue&type=script&lang=js&"
import style0 from "./questionPreview.vue?vue&type=style&index=0&id=5ea30c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea30c6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDivider,VIcon})
